module.exports = __webpack_public_path__ + "static/media/m_beard_shortboxed_long__square_vector.13e045c7.svg";